import styled from "styled-components";
import { Modal } from "components/Modal";

export const ChoosePlanModalContainer = styled(Modal)`
  .modal-dialog {
    width: 92vw;
    max-width: 1440px;
    font-family: "Geist", sans-serif;
  }

  .modal-content {
    padding: 0;
    border: none;
    border-radius: 20px;
    margin: 0;
    position: relative;
  }

  .modal-body {
    padding: 0;
    margin: 0;
  }

  .heading {
    padding: 28px 32px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    h2 {
      font-family: "Geist", sans-serif;
      color: #181d27;
      font-size: 28px;
      font-weight: 600;
      margin-bottom: 0;
      text-align: center;
    }

    .renewal-notice {
      display: flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.09);
      border-radius: 10px;
      box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.06);
      padding: 8px 14px;
      font-size: 13px;
      color: #535862;

      .renewal-icon {
        flex-shrink: 0;
        opacity: 0.6;
        color: #535862;
      }

      &.scheduled {
        flex-wrap: wrap;
        gap: 8px 10px;
      }

      .reactivate-btn {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px;
        border-radius: 8px;
        border: none;
        background: #181d27;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        font-family: "Geist", sans-serif;
        cursor: pointer;
        white-space: nowrap;
        transition: background 0.15s ease;

        &:hover {
          background: #2d3748;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .inline-loader {
          width: 14px !important;
          height: 14px !important;

          .loader {
            color: #fff;

            .spinner-border {
              width: 14px;
              height: 14px;
              border-width: 2px;
            }
          }
        }
      }
    }
  }

  .plan-container {
    padding: 0 32px 28px;

    .plan-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
    }

    .plan-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 1rem;
      width: 100%;
      align-items: stretch;
    }

    .us-residents-disclaimer {
      margin-top: 20px;
      padding: 0 4px;
      font-size: 12px;
      color: ${({ theme }) => theme.typography.color.secondary};
      line-height: 18px;
      text-align: center;
    }
  }
`;

export const PillToggle = styled.div`
  display: flex;
  background: #f0f0f0;
  border-radius: 100px;
  padding: 4px;
  gap: 2px;

  .toggle-pill {
    padding: 8px 18px;
    border-radius: 100px;
    border: none;
    background: transparent;
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #181d27;
    cursor: pointer;
    transition: background 0.22s ease, box-shadow 0.22s ease, opacity 0.22s ease;
    white-space: nowrap;
    opacity: 0.5;

    &.active {
      background: #fff;
      opacity: 1;
      box-shadow: 0px 1px 3px rgba(10, 13, 18, 0.12),
        0px 1px 2px rgba(10, 13, 18, 0.08);
    }

    &:not(.active):hover {
      opacity: 0.75;
    }

    .save-text {
      color: #406ad0;
    }
  }
`;
